import React from 'react'

import { GlobalFontStyles } from './fonts'
import { GlobalNormalizeStyles } from './normalize'
import { GlobalDefaultStyles } from './styles'

const GlobalStyles = () => (
  <>
    <GlobalFontStyles key="fonts" />
    <GlobalNormalizeStyles key="normalize" />
    <GlobalDefaultStyles key="global" />
  </>
)

export { GlobalStyles }
